function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M52.8053 26.8696C52.8053 40.6046 41.6708 51.7391 27.9357 51.7391C18.2605 51.7391 9.87574 46.2142 5.76424 38.1472L5.98236 38.235C9.60853 38.7286 18.7548 37.5776 24.9492 31.7352L22.9117 32.0707C22.6735 32.1096 22.43 32.1497 22.1818 32.1905L22.1818 32.1905C17.7294 32.9236 11.7435 33.9091 6.84507 32.8072C5.92148 32.5994 3.94021 31.8678 3.28299 30.1681C3.13997 29.0889 3.06616 27.9879 3.06616 26.8696C3.06616 13.1345 14.2006 2 27.9357 2C41.6708 2 52.8053 13.1345 52.8053 26.8696ZM22.739 27.287L27.6282 32.138L34.7587 28.972L37.0957 36.2061L40.3269 34.615V26.8696L48.5044 23.1474C48.9459 22.9465 49.1926 22.4696 49.1018 21.9932C48.9356 21.1223 48.2413 20.4492 47.3658 20.31L44.6154 19.8729C43.2129 19.6501 41.7767 19.9234 40.5542 20.6459L38.8075 21.6781L32.8236 18.9255L31.1775 19.5281L33.389 24.484L36.1251 23.4459L28.1895 28.0664L24.6247 26.5404L22.739 27.287Z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M1.17292 29.6707C1.60432 31.3712 2.2354 32.5207 3.06617 33.1192C6.53513 35.6183 13.3918 35.4365 22.739 32.6277C19.0892 34.9831 12.0929 36.8837 8.5464 36.8837C4.99993 36.8837 3.52801 36.299 2.29258 35.1799C1.44491 34.4121 0.635993 32.6277 1.17292 29.6707Z",
  clipRule: "evenodd",
  opacity: 0.6
});

function SvgFlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.f9e323ed.svg";
export { ForwardRef as ReactComponent };